import dynamic from 'next/dynamic';
import AnnouncementBarTastic from './bar/announcment';
import CategorySliderTastic from './category-slider';
import HeroTastic from './content/hero';
import Tile from './content/tile';
import TilesGroupTastic from './content/tiles-group';
import ContentSliderTastic from './content-slider';
import Footer from './footer';
import Header from './header';
import NotFoundTastic from './not-found';
import ProductSlider from './products/slider';
import SpacerTastic from './spacer';
import { TasticRegistry } from './types';
import ProductTastic from './content/product-section';
import SegmentTastic from './content/segments';
import CollectionTasic from './content/image-content-slider';
import DiscoverTastic from './content/discover';
import BrandTastic from './content/brand';
import PLPCMSComponentTastic from './products/plp-cms-component';
import ImageOnlySliderTastic from './content/image-only-slider';
import ImageWithTextTasic from './content/image-with-text';
import ContentstackBlogListTastic from './content/entry-list-view';
import ImageWithTextDynamicTastic from './content/image-with-text-dynamic';
import PressReleasesCoverTastic from './content/press-releases/cover';
import ExperienceCenterTastic from './experience-center'; 
import ContentstackRenderer from './content/press-releases';
import ContentstackVideoGrid from './content/media-video';
import ContentstackIndustryPapers from './content/industry-papers';
import OurStoryPageTastic from './our-story';
import ProductSliderAlgoliaTastic from './products/related-products-algolia';
import ScrollToTopTastic from './scroll-to-top';
import NeedRenoTastic from './content/need-reno';
import ContactSliderTastic from './content/contact/index';
import WarrantyTastic from './content/warranty';
import DisclaimerTastic from './content/disclaimer';
import ContentWithBannerCMS from './content/content-with-banner-cms';
import PrivacyPageTastic from './privacy-page';
import CollectionTastic from './products/collection';
import NoResultFoundTastic from './no-result';
import ProjectBuilderTastic from './project-builder-page';
import ProjectBuilderDashboard from './project-builder-page/dashboard';
import ShareProjectTastic from './project-builder-page/share-project';
import MyAccountTastic from './account/my-account';
import ExperienceCenterLocationSpecificTastic from './experience-center/location-specific';
import ProductSEO from './products/product-seo';
import DynamicContainerTastic from './content/dynamic-table';

const Markdown = dynamic(() => import('./markdown'));
const AccountDetails = dynamic(() => import('./account/details'));
const AccountLogin = dynamic(() => import('./account/login'));
const AccountOrdersHistory = dynamic(() => import('./account/orders'));
const AccountRegister = dynamic(() => import('./account/register'));
const ResetPassword = dynamic(() => import('./account/reset-password'));
const AccountVerificationTastic = dynamic(() => import('./account/verify'));
const CompanyRegistrationTastic = dynamic(() => import('./account/company-registration'));
const Checkout = dynamic(() => import('./checkout'));
const ThankYou = dynamic(() => import('./thank-you'));
const ProductDetails = dynamic(() => import('./products/details'));
const ProductList = dynamic(() => import('./products/product-list'));
const ProductListAlgolia = dynamic(() => import('./products/product-list-algolia'));
const SimilarProducts = dynamic(() => import('./products/similar-products'));
const OtherProducts = dynamic(() => import('./products/other-products'));
const Showcase = dynamic(() => import('./showcase'));
const TilesMultipleCTATastic = dynamic(() => import('./content/tiles-multiple-cta'));
const Cart = dynamic(() => import('./cart'));

export const tastics = {
  'commercetools/ui/checkout': Checkout,
  'commercetools/ui/thank-you': ThankYou,
  'commercetools/ui/footer': Footer,
  'commercetools/ui/header': Header,
  'commercetools/ui/content/tile': Tile,
  'commercetools/ui/content/hero': HeroTastic,
  'commercetools/ui/content/discover-more': DiscoverTastic,
  'commercetools/ui/content/spacer': SpacerTastic,
  'commercetools/ui/content/showcase': Showcase,
  'commercetools/ui/content/markdown': Markdown,
  'commercetools/ui/cart': Cart,
  'commercetools/ui/content/products': ProductTastic,
  'commercetools/ui/content/segments': SegmentTastic,
  'commercetools/ui/content/collection-slider': CollectionTasic,
  'commercetools/image-only-slider': ImageOnlySliderTastic,
  'commercetools/ui/content/brands': BrandTastic,
  'commercetools/ui/products/details': ProductDetails,
  'commercetools/ui/products/product-list': ProductList,
  'commercetools/ui/products/product-list-algolia': ProductListAlgolia,
  'commercetools/ui/products/slider': ProductSliderAlgoliaTastic,
  'commercetools/ui/products/similar-products': SimilarProducts,
  'commercetools/ui/products/other-products': OtherProducts,
  'commercetools/ui/account/details': AccountDetails,
  'commercetools/ui/account/login': AccountLogin,
  'commercetools/ui/account/register': AccountRegister,
  'commercetools/ui/account/orders': AccountOrdersHistory,
  'commercetools/ui/account/reset-password': ResetPassword,
  'commercetools/ui/account/verify': AccountVerificationTastic,
  'commercetools/ui/account/company-registration': CompanyRegistrationTastic,
  'commercetools/ui/category-slider': CategorySliderTastic,
  'commercetools/ui/content/announcement-bar': AnnouncementBarTastic,
  'commercetools/ui/content/content-slider': ContentSliderTastic,
  'commercetools/ui/content/tiles-group': TilesGroupTastic,
  'commercetools/ui/not-found': NotFoundTastic,
  'commercetools/plp-cms-component': PLPCMSComponentTastic,
  'commercetools/image-with-text': ImageWithTextTasic,
  'commercetools/image-with-text-dynamic': ImageWithTextDynamicTastic,
  'commercetools/entry-list-view': ContentstackBlogListTastic,
  'commercetools/pr-cover': PressReleasesCoverTastic,
  'commercetools/cs-renderer': ContentstackRenderer,
  'commercetools/media-videos': ContentstackVideoGrid,
  'commercetools/industry-papers': ContentstackIndustryPapers,
  'commercetools/cs-table': DynamicContainerTastic,
  'commercetools/ui/our-story': OurStoryPageTastic,
  'commercetools/ui/products/scroll-to-top': ScrollToTopTastic,
  'commercetoole/ui/need-reno': NeedRenoTastic,
  'commercetools/ui/product/seo': ProductSEO,
  'commercetools/ui/privacy': PrivacyPageTastic,
  'commercetools/tiles-multiple-cta': TilesMultipleCTATastic,
  'commercetools/ui/contact': ContactSliderTastic,
  'commercetools/ui/experience-center/location-specific-landing-page': ExperienceCenterLocationSpecificTastic,
  'commercetools/ui/experience-center/experience-center-landing-page': ExperienceCenterTastic,
  'commercetools/ui/content/warranty-page': WarrantyTastic,
  'commercetools/ui/content/disclaimer': DisclaimerTastic,
  'commercetools/ui/content/sector-content': ContentWithBannerCMS,
  'cms/contentstack/collection': CollectionTastic,
  'commercetools/ui/no-result-found': NoResultFoundTastic,
  'commercetools/ui/project-builder': ProjectBuilderTastic,
  'commercetools/ui/dashboard-project-builder': ProjectBuilderDashboard,
  'commercetools/ui/share-project-summary': ShareProjectTastic,
  'commercetools/ui/account/my-account': MyAccountTastic,
} as TasticRegistry;
